import { useEffect, useState } from 'react';
import { Session, LeaderboardResponse } from '../api/types';
import { API_URLS } from '../config/api';

/**
 * Client-side provisional rank for the completion screen: fetch the
 * leaderboard and find this session's position. No backend change — the
 * completion screen never waits on this, and a miss (below the 100-entry
 * cap, sub-two-pub session, or a failed fetch) just means no line is shown.
 */
export const useProvisionalRank = (session: Session | null): number | null => {
  const [rank, setRank] = useState<number | null>(null);

  useEffect(() => {
    setRank(null);
    if (!session?.crawlId) return undefined;

    let cancelled = false;
    (async () => {
      try {
        const response = await fetch(API_URLS.LEADERBOARD(session.crawlId));
        if (!response.ok) return;
        const data: LeaderboardResponse = await response.json();
        const index = data.leaderboard.findIndex(entry => entry.sessionId === session.id);
        if (!cancelled && index !== -1) {
          setRank(index + 1);
        }
      } catch (error) {
        console.error('Failed to fetch provisional rank:', error);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [session?.crawlId, session?.id]);

  return rank;
};
